import { BaseEntity } from '@base-entities';
import { DatabaseDeletionTransformer } from '../transformers';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeDatabaseDeletionTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new DatabaseDeletionTransformer<E>();
}
